import { render, staticRenderFns } from "./Impact.vue?vue&type=template&id=b7e61a80&scoped=true&"
import script from "./Impact.vue?vue&type=script&lang=js&"
export * from "./Impact.vue?vue&type=script&lang=js&"
import style0 from "./Impact.vue?vue&type=style&index=0&id=b7e61a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e61a80",
  null
  
)

export default component.exports